import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import ResepObatSvc from "@/services/ResepObat";

interface RefData {
  id: string | number;
  nama: string;
}

@Module({ store, dynamic: true, name: "referensi-resep", namespaced: true })
class ReferensiResep extends VuexModule {
  public refRute: RefData[] = [];
  public refFrekuensi: RefData[] = [];
  public refSediaan: RefData[] = [];

  @Mutation
  public SET_RUTE(data: RefData[]): void {
    this.refRute = data;
  }

  @Action
  public getRefRute(): void {
    ResepObatSvc.getRefRute().then(data => {
      this.SET_RUTE(data.data);
    });
  }

  @Mutation
  public SET_FREKUENSI(data: RefData[]): void {
    this.refFrekuensi = data;
  }

  @Action
  public getRefFrekuensi(): void {
    ResepObatSvc.getRefFrekuensi().then(data => {
      this.SET_FREKUENSI(data.data);
    });
  }

  @Mutation
  public SET_SEDIAAN(data: RefData[]): void {
    this.refSediaan = data;
  }

  @Action
  public getRefSediaan(): void {
    ResepObatSvc.getRefSediaan().then(data => {
      this.SET_SEDIAAN(data.data);
    });
  }
}

export const refResepStore = getModule(ReferensiResep);
